import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/entities/auth.service';
import { PermissionService } from '@core/services/presenters/permission.service';
import { LocalStorageService } from '@core/services/infrastructure/localstorage.service';
import {
  STORAGE_USER_PERSON,
  STORAGE_ORGANIZATION_COMPANY,
} from '@shared/utils/constants/storage.constant';
import { lastValueFrom } from 'rxjs';
import { CapabilityPermissionMapper } from '@domain/capability-permission/mappers/capability-permission.mapper';

export const AuthGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const permissionService = inject(PermissionService);
  const localStorageService = inject(LocalStorageService);

  try {
    const haveToken = authService.currentAccessToken;
    if (!haveToken) throw new Error('AuthGuard | No token available');
    const response = await lastValueFrom(authService.validate());
    localStorageService.setItem(STORAGE_USER_PERSON, JSON.stringify(response.data.userPerson));
    localStorageService.setItem(STORAGE_ORGANIZATION_COMPANY, JSON.stringify(response.data.organizationCompany));

    const capabilityPermissionMapper = new CapabilityPermissionMapper();
    const listCapabilityPermission = response.data.capabilityPermissions.map(item =>
      capabilityPermissionMapper.mapDtoToModel(item)
    );

    permissionService.initializePermissions(listCapabilityPermission);
    return true;
  } catch {
    authService.logout();
    router.navigate(['/auth/sign-in']);
    return false;
  }
};